import * as Types from '../types-api.generated';

import { UserMicroFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiMomentsByExhibitionVariables = Types.Exact<{
  exhibitionId: Types.Scalars['Int'];
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiMomentsByExhibition = { moments: { totalItems: number, page: number, totalPages: number, items: Array<{ id: number, name: string, worldId: number, startsAt: string, posterUrl: string, description: string | null, takeRateInBasisPoints: number, creators: { totalItems: number, items: Array<{ profileImageUrl: string | null, username: string | null, publicKey: Address }> } }> } };



export const ApiMomentsByExhibitionDocument = /*#__PURE__*/ `
    query MomentsByExhibition($exhibitionId: Int!, $page: Int, $perPage: Int) {
  moments: momentsWithCreatorsByExhibition(
    exhibitionId: $exhibitionId
    page: $page
    perPage: $perPage
  ) {
    totalItems
    page
    totalPages
    items {
      id
      name
      worldId
      startsAt
      posterUrl
      description
      takeRateInBasisPoints
      creators {
        totalItems
        items {
          ...UserMicroFragment
        }
      }
    }
  }
}
    ${UserMicroFragment}`;

export const useMomentsByExhibition = <
      TData = ApiMomentsByExhibition,
      TError = ClientError
    >(
      variables: ApiMomentsByExhibitionVariables,
      options?: Omit<UseQueryOptions<ApiMomentsByExhibition, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiMomentsByExhibition, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiMomentsByExhibition, TError, TData>(
      {
    queryKey: ['MomentsByExhibition', variables],
    queryFn: apiFetcher<ApiMomentsByExhibition, ApiMomentsByExhibitionVariables>(ApiMomentsByExhibitionDocument, variables),
    ...options
  }
    )};

useMomentsByExhibition.getKey = (variables: ApiMomentsByExhibitionVariables) => ['MomentsByExhibition', variables];

export const useInfiniteMomentsByExhibition = <
      TData = InfiniteData<ApiMomentsByExhibition>,
      TError = ClientError
    >(
      variables: ApiMomentsByExhibitionVariables,
      options: Omit<UseInfiniteQueryOptions<ApiMomentsByExhibition, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiMomentsByExhibition, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiMomentsByExhibition, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MomentsByExhibition.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiMomentsByExhibition, ApiMomentsByExhibitionVariables>(ApiMomentsByExhibitionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMomentsByExhibition.getKey = (variables: ApiMomentsByExhibitionVariables) => ['MomentsByExhibition.infinite', variables];


useMomentsByExhibition.fetcher = (variables: ApiMomentsByExhibitionVariables, options?: RequestInit['headers']) => apiFetcher<ApiMomentsByExhibition, ApiMomentsByExhibitionVariables>(ApiMomentsByExhibitionDocument, variables, options);
